export default function CssBaseline(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          "&::-webkit-scrollbar": {
            width: 8,
            height: 8,
          },
          "&::-webkit-scrollbar-track": {
            background: theme.palette.grey.g5,
            borderRadius: 8,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: theme.palette.grey.g3,
            borderRadius: 16,
            // border: `4px solid ${theme.palette.grey.g3}`,
          },
        },

        html: {
          width: "100%",
          height: "100%",
          WebkitOverflowScrolling: "touch",
        },
        body: {
          width: "100%",
          height: "100%",
        },
        /* height of the leaflet map container */
        ".leaflet-container": {
          direction: "rtl !important",
          height: "50vh",
          width: "100%",
          borderRadius: "2rem",
        },
        // In otp-input.css
        ".otp-input": {
          direction: "ltr !important",
        },

        input: {
          "&[type=number]": {
            MozAppearance: "textfield",
            "&::-webkit-outer-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
            "&::-webkit-inner-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
          },
        },
        img: {
          display: "block",
          maxWidth: "100%",
        },
        a: {
          textDecoration: "inherit",
          color: "inherit",
        },
      },
    },
  };
}
